module.exports = __webpack_public_path__ + "static/media/03_tn.6464d678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/03_tn.jpg
// module id = 141
// module chunks = 0